// src/components/layout/TopNavBar.js
import React, { useState, useEffect, useRef } from 'react';
import { useAuth } from '../../context/AuthContext';
import { useNavigate } from 'react-router-dom';
// IMPORT NOVO COMPONENTE
import { PersonalDataModal } from '../PersonalDataModal';

const UserIcon = () => (
  <svg className="w-6 h-6 text-gray-400" fill="none" stroke="currentColor" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg"><path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M16 7a4 4 0 11-8 0 4 4 0 018 0zM12 14a7 7 0 00-7 7h14a7 7 0 00-7-7z" /></svg>
);
const KeyIcon = () => (
  <svg className="w-5 h-5 mr-2" fill="none" stroke="currentColor" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg"><path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M15 7a2 2 0 012 2v5a2 2 0 01-2 2h-5a2 2 0 01-2-2V9a2 2 0 012-2h5z" /><path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M17 17v2a2 2 0 01-2 2H5a2 2 0 01-2-2V9a2 2 0 012-2h2L7 9m0 0l-2 2" /></svg>
);
// ÍCONE NOVO PARA DADOS PESSOAIS
const IdCardIcon = () => (
  <svg className="w-5 h-5 mr-2" fill="none" stroke="currentColor" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg"><path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M10 6H5a2 2 0 00-2 2v9a2 2 0 002 2h14a2 2 0 002-2V8a2 2 0 00-2-2h-5m-4 0V5a2 2 0 114 0v1m-4 0a2 2 0 104 0m-5 8a2 2 0 100-4 2 2 0 000 4zm0 0c1.306 0 2.417.835 2.83 2M9 14a3.001 3.001 0 00-2.83 2M15 11h3m-3 4h2" /></svg>
);
const LogoutIconDropdown = () => (
  <svg className="w-5 h-5 mr-2 text-red-500" fill="none" stroke="currentColor" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg"><path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M17 16l4-4m0 0l-4-4m4 4H7m6 4v1a3 3 0 01-3 3H6a3 3 0 01-3-3V7a3 3 0 013-3h4a3 3 0 013 3v1" /></svg>
);

export const TopNavBar = ({ onToggleSidebar, onOpenChangePassword }) => {
  const [isDropdownOpen, setIsDropdownOpen] = useState(false);
  // ESTADO NOVO
  const [showPersonalDataModal, setShowPersonalDataModal] = useState(false);
  
  const { userProfile, logoutApp } = useAuth();
  const navigate = useNavigate();
  const dropdownRef = useRef(null);

  const handleLogout = () => {
    logoutApp();
    navigate('/login');
  };

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
        setIsDropdownOpen(false);
      }
    };
    document.addEventListener('mousedown', handleClickOutside);
    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
    };
  }, []);

  return (
    <nav className="fixed top-0 z-50 w-full bg-gray-900 border-b border-gray-700">
      <div className="px-3 py-3 lg:px-5 lg:pl-3">
        <div className="flex items-center justify-between">
          <div className="flex items-center justify-start">
            
            <button
              onClick={onToggleSidebar}
              aria-controls="logo-sidebar"
              type="button"
              className="inline-flex items-center p-2 text-sm text-gray-400 rounded-lg hover:bg-gray-700 focus:outline-none focus:ring-2 focus:ring-gray-600"
            >
              <span className="sr-only">Open sidebar</span>
              <svg className="w-6 h-6" aria-hidden="true" fill="currentColor" viewBox="0 0 20 20" xmlns="http://www.w3.org/2000/svg">
                <path clipRule="evenodd" fillRule="evenodd" d="M2 4.75A.75.75 0 012.75 4h14.5a.75.75 0 010 1.5H2.75A.75.75 0 012 4.75zm0 10.5a.75.75 0 01.75-.75h7.5a.75.75 0 010 1.5h-7.5a.75.75 0 01-.75-.75zM2 10a.75.75 0 01.75-.75h14.5a.75.75 0 010 1.5H2.75A.75.75 0 012 10z"></path>
              </svg>
            </button>
            
            <a href="/" className="flex ms-2 md:me-22 items-center">
                <div className="flex flex-col items-start">
                    <span className="text-5xl font-extrabold text-blue-400">APMBB</span>
                    <span className="text-xs text-gray-400 leading-tight">
                        Sistema Integrado Acadêmico 
                    </span>
                </div>
            </a>
          </div>

          <div className="flex items-center">
            <div className="flex items-center ms-3" ref={dropdownRef}>
              <div>
                <button
                  type="button"
                  className="flex text-sm p-2 rounded-full focus:ring-4 focus:ring-gray-600 hover:bg-gray-700"
                  onClick={() => setIsDropdownOpen(!isDropdownOpen)}
                >
                  <span className="sr-only">Open user menu</span>
                  <UserIcon />
                </button>
              </div>
              
              {isDropdownOpen && (
                 <div className="z-50 absolute right-0 top-10 mt-2 w-56 list-none bg-gray-700 divide-y divide-gray-600 rounded-lg shadow-lg">
                  <div className="px-4 py-3" role="none">
                    <p className="text-sm text-white" role="none">
                      {userProfile?.nome || 'Usuário'}
                    </p>
                    <p className="text-sm font-medium text-gray-300 truncate" role="none">
                      Nível: {userProfile?.nivel || 'N/D'}
                    </p>
                  </div>
                  <ul className="py-1" role="none">
                    
                    {/* NOVA OPÇÃO: DADOS PESSOAIS */}
                    <li>
                      <button
                        onClick={() => {
                          setShowPersonalDataModal(true);
                          setIsDropdownOpen(false);
                        }}
                        className="flex items-center w-full px-4 py-2 text-sm text-gray-200 hover:bg-gray-600 hover:text-white"
                      >
                        <IdCardIcon /> Dados pessoais
                      </button>
                    </li>

                    <li>
                      <button
                        onClick={() => {
                          onOpenChangePassword();
                          setIsDropdownOpen(false);
                        }}
                        className="flex items-center w-full px-4 py-2 text-sm text-gray-200 hover:bg-gray-600 hover:text-white"
                      >
                        <KeyIcon /> Alterar Senha
                      </button>
                    </li>
                    <li>
                      <button
                        onClick={handleLogout}
                        className="flex items-center w-full px-4 py-2 text-sm text-red-400 hover:bg-gray-600 hover:text-white"
                      >
                        <LogoutIconDropdown /> Sair
                      </button>
                    </li>
                  </ul>
                </div>
              )}
              
            </div>
          </div>
        </div>
      </div>

      {/* RENDERIZAÇÃO DO MODAL */}
      <PersonalDataModal 
        show={showPersonalDataModal} 
        onClose={() => setShowPersonalDataModal(false)} 
        userProfile={userProfile} 
      />

    </nav>
  );
};